import useGenesStore from '../../store/store';
import ChildrenList from './items/children/ChildrenList';

function Result() {
  const { result } = useGenesStore();
  return typeof result === 'undefined' ? null : <ChildrenList />;
}

export default Result;
